import http from '@/utils/request.js'

export function getDicts(dictType) {
  return http.request({
    url: '/system/dict/data/type/' + dictType,
    method: 'get'
  })
}